import React from 'react';
import { Text } from '@naf/text';
import { useLocation } from 'react-router-dom';
import { useResolvedNavigationLink } from '../../../../hooks/useResolvedNavigationLink';
import { HighlightedLinksType } from '../../../../../../types/globalSettingsType';
import { useHandleNavigationClick } from '../../../../utils/Tracking/Navigation/NavigationTracking';
import * as S from './HighlightedLinkItem.styles';

interface HighlightedLinkProps {
  item?: HighlightedLinksType | null;
}

export const HighlightedLink = ({ item }: HighlightedLinkProps) => {
  const location = useLocation();
  const linkData = item?.link?.link?.data;
  const { url, blank } = useResolvedNavigationLink({
    data: linkData,
    type: item?.link?.link?.type,
  });

  const handleOnClick = useHandleNavigationClick({
    event: 'highlightedLinkClick',
    menuPage: location.pathname,
    menuSectionName: 'highlightedLink',
    menuItemName: item?.link?.header ?? '',
    menuItemUrl: url,
  });

  if (!item?.link?.header || !url) return null;

  return (
    <S.Container>
      <S.LinkItem url={url} blank={blank} onClick={handleOnClick}>
        <Text tag="span">{item.link.header}</Text>
      </S.LinkItem>
    </S.Container>
  );
};
